module.exports = __webpack_public_path__ + "static/media/lsyg.ea46183a.jpg";